import { css } from "@emotion/css";
import { withBasicStyles } from "@/styles/common";

export const useStyles = withBasicStyles(() => ({
  container: css`
    display: flex;
    width: 100%;
    height: 500px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
  `,
  containerNoPreview: css`
    height: auto;
    border: none;
    border-radius: 0;
    & > *:first-child {
      border-right: none;
    }
  `,
  directoryPanel: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    border-right: 1px solid #e8e8e8;
    background: var(--folder-tree-directory-bg, #fafafa);
  `,
  directoryTitle: css`
    padding: 12px 16px;
    font-weight: 600;
    font-size: 14px;
    border-bottom: 1px solid #e8e8e8;
    color: #333;
  `,
  directoryTreeContent: css`
    padding: 4px 8px;
    flex: 1;

    .ant-tree {
      background: transparent;
      height: 100%;
    }
    .ant-tree-switcher {
      margin-right: 0;
    }
    .ant-tree .ant-tree-node-content-wrapper {
      display: inline-flex;
      align-items: center;
      flex: 1;
      min-width: 0;
      padding-left: 0;
      overflow: hidden;
    }
    .ant-tree .ant-tree-title {
      flex: 1;
      min-width: 0;
      overflow: hidden;
    }
    .ant-tree-directory .ant-tree-treenode {
      position: relative;
      &::before {
        border-radius: 4px;
      }
    }
    /* 自定义拖拽样式 — 基于 ant-tree-treenode 定位，覆盖整行 */
    .ant-tree-treenode.folder-tree-drop-before::after {
      content: "";
      position: absolute;
      top: -2px;
      left: 0;
      right: 0;
      height: 2px;
      background: transparent;
      border-top: 2px dashed #1677ff;
      z-index: 10;
      pointer-events: none;
    }
    .ant-tree-treenode.folder-tree-drop-inside::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 2px dashed #1677ff;
      border-radius: 4px;
      background: rgba(22, 119, 255, 0.04);
      z-index: 10;
      pointer-events: none;
    }
    .ant-tree-treenode.folder-tree-drop-after::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 2px;
      background: transparent;
      border-bottom: 2px dashed #1677ff;
      z-index: 10;
      pointer-events: none;
    }
  `,

  /** 自定义拖拽 - 节点可拖拽样式 */
  dragNodeHandle: css`
    cursor: grab;
    user-select: none;

    &:active {
      cursor: grabbing;
    }
  `,
  /** 树节点容器，用于相对定位 drop indicator */
  treeNodeWrapper: css`
    position: relative;
    min-width: 0;
    overflow: hidden;
  `,
  previewPanel: css`
    flex: 1;
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
  `,
  previewTitle: css`
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 500;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333;
    background: #fff;
  `,
  previewContent: css`
    flex: 1;
    overflow: auto;
    padding: 16px;
    font-size: 13px;
    line-height: 1.6;
  `,
  emptyContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  `,
  loadingContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  `,
  treeNodeTitle: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
    overflow: hidden;
    padding-right: 4px;

    > span:first-child {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `,
  moreIcon: css`
    opacity: 0;
    cursor: pointer;
    padding: 0 4px;
    margin: 2px;
    color: #999;
    font-size: 12px;
    line-height: 20px;
    transition: all 0.2s;
    height: 20px;
    box-sizing: border-box;

    &:hover {
      border-radius: 50%;
      color: #333;
      background: rgba(0, 0, 0, 0.04);
    }
  `,
  treeNodeTitleHover: css`
    &:hover .folder-tree-more-icon {
      opacity: 1;
    }
  `,
  inlineInput: css`
    width: 100%;
    .ant-input {
      height: 22px;
      font-size: 13px;
      padding: 0 6px;
      border-radius: 4px;
    }
  `,
  copyBtn: css`
    cursor: pointer;
    color: #999;
    font-size: 14px;
    &:hover {
      color: #1677ff;
    }
  `,
}));
